<template>
  <div class="d-flex">
    <v-dialog
      v-model="dialogCustomColumns"
      width="300"
      content-class="dialog-custom-columns"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-auto rounded-lg px-0 align-self-center"
          min-width="39px"
          height="39"
          color="white"
          v-bind="attrs"
          v-on="on"                  
        >
          <v-icon>mdi-tune</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-caption font-weight-light d-flex px-8">
          <p class="mr-auto pt-4">Customize columns</p>
          <v-btn
            text
            class="text-caption font-weight-light ml-auto text-capitalize pt-0"
            color="blue darken-4"
            @click="allColumns"
          >
            Select All
          </v-btn>
        </v-card-title>
        <draggable
          :list="headers"
          ghost-class="ghost"
          @start="dragging = true"
          @end="dragging = false"

        >
          <v-checkbox 
            v-for="item in headers" 
            :key="item.text"
            v-model="customHeader"
            :label="item.text"
            :value="item.value"
            dense
            class="pa-0 ma-0 ml-6 checkbox-label"
            height="8"
          ></v-checkbox>
        </draggable>
        <v-card-actions class="flex-column ml-4">
          <v-btn
            text
            color="grey darken-1"
            class="text-caption font-weight-light mr-auto text-capitalize"
            @click="saveCustomeView"
          >
            Save a custome view
            <v-icon
              right
              dark
            >
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-btn
            text
            color="grey darken-1"
            class="text-caption font-weight-light mr-auto ml-0 text-capitalize mb-5"
            @click="restoreCustomeView"
          >
            Restore to default
            <v-icon
              right
              dark
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"

export default {
  components: {
    draggable
  },
  props: {
    currentValue: {
      type: Array
    },
    currentCustomHeader: {
      type: Array
    },
    currentHeaders: {
      type: Array
    },
    settingsName: {
      type: String
    }
  },
  data() {
    return {
      dialogCustomColumns: false,
      headers: [],
      value: [],
      customHeader: [],
      selectedHeaders: [],
      defaultCustomHeader: [],
      dragging: false,
    }
  },
  mounted(){
    this.value = this.currentValue
    this.customHeader = this.currentCustomHeader
    this.defaultCustomHeader = this.currentCustomHeader

    let userName = localStorage.getItem('username')
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
    this.headers = (localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`)) 
                    ? JSON.parse(localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`))
                    : this.currentHeaders.slice()
  },
  watch: {
    currentValue(){
      this.value = this.currentValue
    },
    currentCustomHeader(){
      this.customHeader = this.currentCustomHeader
    },
    currentHeaders(){
      let userName = localStorage.getItem('username')
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      this.headers = (localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`)) 
                ? JSON.parse(localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`))
                : this.currentHeaders.slice()
    },
    value(val) {
      this.selectedHeaders = val
    },
    settingsName(){
      this.value = this.currentValue
      this.customHeader = this.currentCustomHeader
      this.defaultCustomHeader = this.currentCustomHeader
      this.selectedHeaders = this.value

      let userName = localStorage.getItem('username')
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      this.headers = (localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`)) 
                ? JSON.parse(localStorage.getItem(`${userName}.${clientId}.${this.settingsName}.draggingHeaders`))
                : this.currentHeaders.slice()
    }
  },
  created() {
    this.selectedHeaders = this.value
  },
  methods: {
    saveCustomeView() {
      this.value = []
      this.headers.map(e => {
        for (let i = 0; i < this.customHeader.length; i++) {
          if (this.customHeader[i] == e.value) {
            this.value.push(e)
          }       
        }
      })

      this.saveCustomeSettins()
      this.sentData()
      this.dialogCustomColumns = false     
    },
    saveCustomeSettins(){
      let userName = localStorage.getItem('username')
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      let settingsName = this.settingsName

      const value = JSON.stringify(this.value)
      localStorage.setItem(`${userName}.${clientId}.${settingsName}`, value)

      const draggingHeaders = JSON.stringify(this.headers)
      localStorage.setItem(`${userName}.${clientId}.${settingsName}.draggingHeaders`, draggingHeaders)

    },
    allColumns() {
      this.value = []
      this.customHeader = []
      this.headers.map(e => {
        this.customHeader = [...this.customHeader, e.value]
      })
    },
    restoreCustomeView() {
      this.customHeader = this.defaultCustomHeader
      let userName = localStorage.getItem('username')
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1
      let settingsName = this.settingsName
      localStorage.removeItem(`${userName}.${clientId}.${settingsName}`)
      localStorage.removeItem(`${userName}.${clientId}.${settingsName}.draggingHeaders`)

      this.value = []
      for (let i = 0; i < this.customHeader.length; i++) {
        this.headers.map(e => {
          if (this.customHeader[i] == e.value){
            this.value.push(e)
          }      
        })
      }

      this.headers = this.currentHeaders
      this.selectedHeaders = this.value

      this.sentData()
      this.dialogCustomColumns = false
    },
    sentData(){
      this.$emit('getCustomData', { 
                      customHeader: this.customHeader, 
                      value: this.value, 
                      selectedHeaders: this.selectedHeaders
                      })
    }
  }
}
</script>

<style>
  .dialog-custom-columns {
    position: absolute;
    bottom: 0;
    right: 0;
    overflow-x: hidden;
  }
  .test table > tbody > tr > td:nth-child(1), 
  .theme--light.v-data-table .v-data-table__wrapper > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0;
    top: 0;
    background: white;
  }
  .checkbox-label label {
    font-size: 13px !important;
    color: #505050 !important;
  }
  .checkbox-label .v-icon.v-icon--dense {
    font-size: 13px !important;
    color: #505050 !important;
    margin: 0;
    border: 1px solid #9E9E9E;
    width: 11px;
    height: 11px;
  }
</style>
